import {Body} from '@cjdev-internal/visual-stack/lib/components/Panel';
import {WELCOME_MESSAGE} from "../../constants/appConstant";
import "./message.css";
import {ErrorPage} from "@cjdev-internal/visual-stack-x/ErrorPage";
import React from "react";

const Message = (WelcomePageButton) => {
    return function Message({companiesName}) {
        return (
            <Body>
                {
                    companiesName.length === 0 ?
                        (<ErrorPage autoPosition={true}
                                    errorCode={403}/>) :
                        (<>
                            <h3 className="message_align">{WELCOME_MESSAGE}</h3>
                            <WelcomePageButton/>
                        </>)
                }
            </Body>
        );
    }
};

export default Message;